import { Injectable, OnInit } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Config } from "../../../core/config";
import { ClientTxnReq, ClientTxnRes } from "../model/clientTxnRequest";
import { DataStore } from "../../../shared/data-store.service";



@Injectable()
export class TransactionsService {

  url:string;

  constructor(private http: HttpClient, private resource: Config,private dataservice:DataStore) {
    this.dataservice.currentBaseUrl$.subscribe(url => this.url = url)
  }
  // url = this.resource.url

  getSettlementData(ctxnReg: ClientTxnReq, clientID: string) {
    let queryParam = new HttpParams();
    queryParam = queryParam
      .set("startDate", ctxnReg.startDate)
      .set("endDate", ctxnReg.endDate)
      .set("pageIndex", ctxnReg.pageIndex.toString())
      .set("pageSize", ctxnReg.pageSize.toString());
    return this.http.get(
      `${this.url}${this.resource.settlement}${clientID}/settlement`,
      { params: queryParam }
    );
  }

  getTransactionDetails(clientId, ref) {

    
    
    return this.http.get(
      `${this.url}${this.resource.txnDetails}${clientId}/transaction?reference=${ref}`
    );
  }

  
 getClientTransactions(ctxnReg: ClientTxnReq, clientID: string) {
  let queryParam = new HttpParams();
  queryParam = queryParam
    .set("reference", ctxnReg.reference)
    .set("startDate", ctxnReg.startDate)
    .set("endDate", ctxnReg.endDate)
    .set("pageIndex", ctxnReg.pageIndex.toString())
    .set("pageSize", ctxnReg.pageSize.toString());
    return this.http.get(
      `${this.url}${this.resource.clientTransactions}${clientID}/transaction`,
      { params: queryParam }
    );

}


  // ,{params:queryParam}
}
